/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Row,
  Col,
  Typography,
  Select,
  notification,
  Button,
  Input,
  Spin,
  Radio,
} from 'antd';
import { connect } from 'react-redux';
import { copyStation } from '../../redux/PQTstation/action';
import get from 'lodash/get';
import { CopyStations } from '../../redux/PQTstation/saga';
const { Text } = Typography;
const { Option } = Select;

const CopyITPStationTest = ({
  isCopyModalVisible,
  setIsCopyModalVisible,
  locationData,
  onCopyStation,
  isTestCopyLoading,
  ITPPipeline,
  PQtPipeline,
  setLocation,
  selectedPipeline,
  selectStation,
  selectedProject,
  onAddSowDetails,
  isAddPipeLoading,
  isWriteAccess,
  fetchPQTStationTest,
}) => {
  const [form] = Form.useForm();
  const [sourcePipeline, setSourcePipeline] = useState(ITPPipeline);
  const [targetPipelines, setTargetPipelines] = useState(PQtPipeline);
  const [selectedSourcePipeline, setSelectedSourcePipeline] = useState('');
  const [selectedTargetPipeline, setSelectedTargetPipeline] = useState('');

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editDetailsForm] = Form.useForm();
  const [copyType, setCopyType] = useState('PQT');
  const [isCopyLoading, setIsCopyLoading] = useState(false);

  useEffect(() => {
    // Get unique ITP pipeline sections
    const uniqueITPPipelines = Array.from(
      new Set(
        ITPPipeline.filter((item) => item.pipelineSection).map((item) => item.pipelineSection)
      )
    ).map((section) => ({
      pipelineSection: `${section} (${
        ITPPipeline.find((item) => item.pipelineSection === section)?.pipeStringId
      })`,
      id: ITPPipeline.find((item) => item.pipelineSection === section)?.id,
    }));

    // Get unique PQT pipeline sections
    const uniquePQTPipelines = Array.from(
      new Set(
        PQtPipeline.filter((item) => item.pipelineSection).map((item) => item.pipelineSection)
      )
    ).map((section) => ({
      pipelineSection: section,
      id: PQtPipeline.find((item) => item.pipelineSection === section)?.id,
    }));

    if (copyType === 'ITP') {
      setSourcePipeline(uniqueITPPipelines);
    } else {
      setSourcePipeline(uniquePQTPipelines);
    }
    setTargetPipelines(uniquePQTPipelines);
  }, [ITPPipeline, PQtPipeline, copyType]);

  const showModal = () => {
    setIsCopyModalVisible(true);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      console.log(values);
      if (copyType === 'ITP' && !values.fromITP) {
        notification.warning({
          message: 'Select all required fields to proceed!',
        });
        return;
      } else if (copyType === 'PQT' && !values.fromPQT) {
        notification.warning({
          message: 'Select all required fields to proceed!',
        });
        return;
      }
      const data = {
        copyTests: {
          from: copyType === 'ITP' ? values.fromITP : values.fromPQT,
          to: values.toPQT,
        },
      };
      const payload = {
        data,
        copyType,
      };
      setIsCopyLoading(true);
      const response = await CopyStations(payload);
      if (response) {
        form.resetFields();
        setCopyType('PQT');
        await fetchPQTStationTest();
        setIsCopyModalVisible(false);
      }
      setIsCopyLoading(false);
    } catch (error) {
      console.error('Validation error:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setSourcePipeline(ITPPipeline);
    setTargetPipelines(PQtPipeline);
    setIsCopyModalVisible(false);
    setCopyType('PQT');
  };

  const handleSourcePipelineChange = (value) => {
    if (copyType === 'PQT') {
      // Filter out the selected pipeline from target options
      const uniquePQTPipelines = Array.from(
        new Set(
          PQtPipeline.filter((item) => item.pipelineSection && item.id !== value).map(
            (item) => item.pipelineSection
          )
        )
      ).map((section) => ({
        pipelineSection: section,
        id: PQtPipeline.find((item) => item.pipelineSection === section)?.id,
      }));
      setSelectedSourcePipeline(value);
      setTargetPipelines(uniquePQTPipelines);
    } else {
      setSelectedSourcePipeline(value);
    }
  };

  const handleTargetPipelineChange = (selectedValues) => {
    setSelectedTargetPipeline(selectedValues);
  };

  return (
    <>
      <Modal
        width="45vw"
        className="pipeline-modal"
        title="Copy Pipeline Tests"
        centered
        visible={isCopyModalVisible}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="apply" type="primary" onClick={handleOk} loading={isCopyLoading}>
            Copy
          </Button>,
        ]}
      >
        {isAddPipeLoading ? (
          <Spin tip="Loading...">
            <div style={{ minHeight: '200px' }} />
            Loading...
          </Spin>
        ) : (
          <Form form={form} name="basic" layout="vertical" autoComplete="off">
            <Row gutter={16}>
              <Col lg={16}>
                <Form.Item name="copy_type" label="Copy From" required className="report-radio">
                  <div>
                    <Radio.Group
                      style={{ display: 'inline-flex' }}
                      onChange={(e) => setCopyType(e.target.value)}
                      value={copyType}
                    >
                      <Radio value={'PQT'}>PQT</Radio>
                      <Radio value={'ITP'}>ITP</Radio>
                    </Radio.Group>
                  </div>
                </Form.Item>
              </Col>
              {copyType === 'ITP' ? (
                <Col lg={12}>
                  <Form.Item label="From ITP Pipeline" name="fromITP" required>
                    <Select
                      className="client-select"
                      placeholder="Select Source Pipeline"
                      onChange={handleSourcePipelineChange}
                      // value={sourcePipeline}
                      allowClear
                      showSearch
                      style={{ borderRadius: '5px' }}
                    >
                      {sourcePipeline &&
                        sourcePipeline.map((item, i) => (
                          <Option key={i} value={item.id}>
                            {item.pipelineSection}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              ) : (
                <Col lg={12}>
                  <Form.Item label="From PQT Pipeline" name="fromPQT" required>
                    <Select
                      className="client-select"
                      placeholder="Select Source Pipeline"
                      onChange={handleSourcePipelineChange}
                      // value={sourcePipeline}
                      allowClear
                      showSearch
                      style={{ borderRadius: '5px' }}
                    >
                      {sourcePipeline &&
                        sourcePipeline.map((item, i) => (
                          <Option key={i} value={item.id}>
                            {item.pipelineSection}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
              <Col lg={12}>
                <Form.Item label="To PQT Pipeline" name="toPQT" required>
                  <Select
                    className="multi-select"
                    placeholder="Select Target Pipelines"
                    onChange={handleTargetPipelineChange}
                    //  value={targetPipelines}
                    allowClear
                    showSearch
                    mode="multiple"
                    size="middle"
                    // dropdownRender={menu => (
                    //     <div>
                    //         {menu}
                    //         <Button style={{ color: '#177ddc' }} onClick={() => setIsModalVisible(true)} type="link">Add New Pipeline</Button>
                    //     </div>
                    // )}
                  >
                    {targetPipelines &&
                      targetPipelines.map((item, i) => (
                        <Option key={i} value={item.id}>
                          {item.pipelineSection}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        )}
        <p style={{ fontSize: '14px', color: 'orangered' }}>
          *Note: Please note that Source Pipeline data will replace existing data in Target
          Pipelines.
        </p>
      </Modal>
    </>
  );
};

const mapStateToProps = ({ stationPQTReducer }) => {
  const isTestCopyLoading = get(stationPQTReducer, 'isTestCopying', []);
  return {
    isTestCopyLoading,
  };
};

const mapDispatchToProps = {
  onCopyStation: copyStation,
};

export default connect(mapStateToProps, mapDispatchToProps)(CopyITPStationTest);
